// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23888%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0px;
  width: 80%;
  gap: 40px;
  text-align: center;
  box-sizing: border-box;
}
.register-unsubscribe-note {
  font-size: 15px;
  color: #888;
  text-align: center;
  margin-top: 14px;
  line-height: 1.4;
}

.register-unsubscribe-note a {
  color: #fff;
  text-decoration: underline;
}

.register-unsubscribe-note a:hover {
  color: #e74c3c;
}
.register-wrapper h2 {
  font-size: 1.7rem;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px;
}

.register-social-icons {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.register-social-btn {
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s, background 0.2s;
}

.register-social-btn:hover {
  border-color: #6C63FF;
  background: #f5f4ff;
}

.register-divider-text {
  font-size: 12px;
  color: #aaa;
  margin: 0 0 16px;
  letter-spacing: 0.3px;
}

.register-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 20px;
}

.register-form input {
  background: #f5f5f5;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  width: 90%;
  font-size: 14px;
  color: #333;
  outline: none;
  transition: background 0.2s;
  box-sizing: border-box;
}

.register-form input:focus {
  background: #eee;
}

.register-submit-btn {
  margin-top: 8px;
  border-radius: 24px;
  border: none;
  width: 80%;
  background: var(--btn-one);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1.5px;
  padding: 13px 48px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
}

.register-submit-btn:hover {
  opacity: 0.92;
}

.register-submit-btn:active {
  transform: scale(0.97);
}

.register-form input,
.country-select-wrapper {
  width: 90%;
  box-sizing: border-box;
}

.custom-phone-input {
  width: 100%;
  background: #f5f5f5 !important;
  border-radius: 8px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 44px;
  border: none;
}

.custom-phone-input .PhoneInput {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent !important;
}

.custom-phone-input .PhoneInputCountry {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.custom-phone-input .PhoneInputCountrySelect {
  background: transparent !important;
  color: #333;
  border: none;
  padding: 4px;
  cursor: pointer;
}

.custom-phone-input .PhoneInputCountryIcon {
  margin-right: 4px;
}

.custom-phone-input .PhoneInputInput {
  flex: 1 1;
  background: transparent !important;
  border: none !important;
  outline: none !important;
  padding: 10px 4px !important;
  font-size: 14px;
  color: #333;
  min-width: 0;
  width: 100%;
}

.custom-phone-input .PhoneInputInput::placeholder {
  color: #999;
}

.custom-phone-input .PhoneInputInput:focus {
  background: transparent !important;
  box-shadow: none !important;
}

.custom-phone-input .PhoneInputCountryIcon--border {
  box-shadow: none !important;
  border: none !important;
}

.custom-phone-input .PhoneInputCountrySelect option {
  background: #f5f5f5;
  color: #333;
}

.country-select-wrapper > div {
  width: 100%;
}

.login-link {
  text-align: center;
  margin-top: 1rem;
  cursor: pointer;
  color: #000;
  transition: all 0.2s ease;
}

.login-link:hover {
  color: var(--bg-secondary);
  font-weight: 600;
  text-decoration: underline;
  border-radius: 4px;
  padding: 0.2rem 0.5rem;
}

.form-row {
  display: flex;
  gap: 16px;
  width: 100%;
  justify-content: center;
}

.form-row > * {
  flex: 1 1;
  min-width: 0;
}

.form-row > .input-group {
  flex: 1 1;
  min-width: 0;
}

.custom-phone-input,
.country-select-wrapper {
  width: 100%;
}

.custom-phone-input .PhoneInput {
  width: 100%;
}

.register-form input,
.custom-phone-input,
.country-select-wrapper,
.password-wrapper {
  width: 100%;
}

.input-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.error-msg {
  color: #e74c3c;
  font-size: 12px;
  text-align: left;
  margin-top: 4px;
}

.password-wrapper {
  position: relative;
  width: 100%;
}

.password-wrapper input {
  width: 100%;
  padding-right: 40px;
  box-sizing: border-box;
}

.eye-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  transition: color 0.2s;
}

.eye-btn:hover {
  color: #333;
}

@media (max-width: 600px) {
  .form-row {
    flex-direction: column;
    gap: 12px;
  }
}

.form-row-full {
  width: 100%;
}

/* Shared select styles for both city and AOI dropdowns */
.form-row select,
.form-row-full select {
  width: 100%;
  background: #f5f5f5;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  outline: none;
  transition: background 0.2s;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
  cursor: pointer;
  height: 44px;
}

.form-row select:focus,
.form-row-full select:focus {
  background-color: #eee;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
}

.form-row select option[value=""],
.form-row-full select option[value=""] {
  color: #aaa;
}

.register-form > * {
  margin-left: auto;
  margin-right: auto;
}

.custom-phone-input .PhoneInputInput {
  background: transparent !important;
  border: none !important;
  outline: none !important;
}

.custom-phone-input .PhoneInputCountrySelect {
  background: transparent !important;
  border: none !important;
  color: #333;
}

.custom-phone-input .PhoneInputCountrySelect option {
  background: #f5f5f5;
  color: #333;
  padding: 8px;
}

.custom-phone-input .PhoneInputCountry {
  background: transparent !important;
}

/* AOI add / remove buttons — match the select style exactly */
.aoi-add-btn {
  height: 44px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  background: #f5f5f5;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  transition: background 0.2s;
}

.aoi-add-btn:hover {
  background: #eee;
}

.aoi-remove-btn {
  height: 44px;
  width: 44px;
  border-radius: 8px;
  border: none;
  background: #f5f5f5;
  font-size: 20px;
  color: #888;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.2s, color 0.2s;
}

.aoi-remove-btn:hover {
  background: #fdecea;
  color: #e74c3c;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/register/Register.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE,WAAW;AACb;;AAEA,yDAAyD;AACzD;;EAEE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,yDAAuL;EACvL,4BAA4B;EAC5B,sCAAsC;EACtC,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,yDAAuL;EACvL,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA,8DAA8D;AAC9D;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".register-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 0px;\n  width: 80%;\n  gap: 40px;\n  text-align: center;\n  box-sizing: border-box;\n}\n.register-unsubscribe-note {\n  font-size: 15px;\n  color: #888;\n  text-align: center;\n  margin-top: 14px;\n  line-height: 1.4;\n}\n\n.register-unsubscribe-note a {\n  color: #fff;\n  text-decoration: underline;\n}\n\n.register-unsubscribe-note a:hover {\n  color: #e74c3c;\n}\n.register-wrapper h2 {\n  font-size: 1.7rem;\n  font-weight: 700;\n  color: #333;\n  margin: 0 0 16px;\n}\n\n.register-social-icons {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.register-social-btn {\n  border: 1px solid #ddd;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  color: #555;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: border-color 0.2s, background 0.2s;\n}\n\n.register-social-btn:hover {\n  border-color: #6C63FF;\n  background: #f5f4ff;\n}\n\n.register-divider-text {\n  font-size: 12px;\n  color: #aaa;\n  margin: 0 0 16px;\n  letter-spacing: 0.3px;\n}\n\n.register-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: 20px;\n}\n\n.register-form input {\n  background: #f5f5f5;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px;\n  width: 90%;\n  font-size: 14px;\n  color: #333;\n  outline: none;\n  transition: background 0.2s;\n  box-sizing: border-box;\n}\n\n.register-form input:focus {\n  background: #eee;\n}\n\n.register-submit-btn {\n  margin-top: 8px;\n  border-radius: 24px;\n  border: none;\n  width: 80%;\n  background: var(--btn-one);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  padding: 13px 48px;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s;\n}\n\n.register-submit-btn:hover {\n  opacity: 0.92;\n}\n\n.register-submit-btn:active {\n  transform: scale(0.97);\n}\n\n.register-form input,\n.country-select-wrapper {\n  width: 90%;\n  box-sizing: border-box;\n}\n\n.custom-phone-input {\n  width: 100%;\n  background: #f5f5f5 !important;\n  border-radius: 8px;\n  padding: 0 12px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  height: 44px;\n  border: none;\n}\n\n.custom-phone-input .PhoneInput {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: transparent !important;\n}\n\n.custom-phone-input .PhoneInputCountry {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.custom-phone-input .PhoneInputCountrySelect {\n  background: transparent !important;\n  color: #333;\n  border: none;\n  padding: 4px;\n  cursor: pointer;\n}\n\n.custom-phone-input .PhoneInputCountryIcon {\n  margin-right: 4px;\n}\n\n.custom-phone-input .PhoneInputInput {\n  flex: 1;\n  background: transparent !important;\n  border: none !important;\n  outline: none !important;\n  padding: 10px 4px !important;\n  font-size: 14px;\n  color: #333;\n  min-width: 0;\n  width: 100%;\n}\n\n.custom-phone-input .PhoneInputInput::placeholder {\n  color: #999;\n}\n\n.custom-phone-input .PhoneInputInput:focus {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.custom-phone-input .PhoneInputCountryIcon--border {\n  box-shadow: none !important;\n  border: none !important;\n}\n\n.custom-phone-input .PhoneInputCountrySelect option {\n  background: #f5f5f5;\n  color: #333;\n}\n\n.country-select-wrapper > div {\n  width: 100%;\n}\n\n.login-link {\n  text-align: center;\n  margin-top: 1rem;\n  cursor: pointer;\n  color: #000;\n  transition: all 0.2s ease;\n}\n\n.login-link:hover {\n  color: var(--bg-secondary);\n  font-weight: 600;\n  text-decoration: underline;\n  border-radius: 4px;\n  padding: 0.2rem 0.5rem;\n}\n\n.form-row {\n  display: flex;\n  gap: 16px;\n  width: 100%;\n  justify-content: center;\n}\n\n.form-row > * {\n  flex: 1;\n  min-width: 0;\n}\n\n.form-row > .input-group {\n  flex: 1;\n  min-width: 0;\n}\n\n.custom-phone-input,\n.country-select-wrapper {\n  width: 100%;\n}\n\n.custom-phone-input .PhoneInput {\n  width: 100%;\n}\n\n.register-form input,\n.custom-phone-input,\n.country-select-wrapper,\n.password-wrapper {\n  width: 100%;\n}\n\n.input-group {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.error-msg {\n  color: #e74c3c;\n  font-size: 12px;\n  text-align: left;\n  margin-top: 4px;\n}\n\n.password-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.password-wrapper input {\n  width: 100%;\n  padding-right: 40px;\n  box-sizing: border-box;\n}\n\n.eye-btn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #888;\n  transition: color 0.2s;\n}\n\n.eye-btn:hover {\n  color: #333;\n}\n\n@media (max-width: 600px) {\n  .form-row {\n    flex-direction: column;\n    gap: 12px;\n  }\n}\n\n.form-row-full {\n  width: 100%;\n}\n\n/* Shared select styles for both city and AOI dropdowns */\n.form-row select,\n.form-row-full select {\n  width: 100%;\n  background: #f5f5f5;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #333;\n  outline: none;\n  transition: background 0.2s;\n  box-sizing: border-box;\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23888' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n  cursor: pointer;\n  height: 44px;\n}\n\n.form-row select:focus,\n.form-row-full select:focus {\n  background-color: #eee;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23888' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n}\n\n.form-row select option[value=\"\"],\n.form-row-full select option[value=\"\"] {\n  color: #aaa;\n}\n\n.register-form > * {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.custom-phone-input .PhoneInputInput {\n  background: transparent !important;\n  border: none !important;\n  outline: none !important;\n}\n\n.custom-phone-input .PhoneInputCountrySelect {\n  background: transparent !important;\n  border: none !important;\n  color: #333;\n}\n\n.custom-phone-input .PhoneInputCountrySelect option {\n  background: #f5f5f5;\n  color: #333;\n  padding: 8px;\n}\n\n.custom-phone-input .PhoneInputCountry {\n  background: transparent !important;\n}\n\n/* AOI add / remove buttons — match the select style exactly */\n.aoi-add-btn {\n  height: 44px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: none;\n  background: #f5f5f5;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  transition: background 0.2s;\n}\n\n.aoi-add-btn:hover {\n  background: #eee;\n}\n\n.aoi-remove-btn {\n  height: 44px;\n  width: 44px;\n  border-radius: 8px;\n  border: none;\n  background: #f5f5f5;\n  font-size: 20px;\n  color: #888;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 0.2s, color 0.2s;\n}\n\n.aoi-remove-btn:hover {\n  background: #fdecea;\n  color: #e74c3c;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
